import { SlotItem, SlotItemDto } from './slots.models';

export function mapSlotItem(dto: SlotItemDto): SlotItem
{
  return {
    id: dto.id,
    clinicId: dto.clinicId,
    deviceId: dto.deviceId,
    specialistUserId: dto.specialistUserId,
    startTime: dto.startTime,
    endTime: dto.endTime,
    status: dto.status,
    source: dto.source,
    blockSource: dto.blockSource ?? null,
    blockReason: dto.blockReason ?? null,
    clinicLabel: dto.clinicLabel ?? null,
    deviceLabel: dto.deviceLabel ?? null,
    specialistLabel: dto.specialistLabel ?? null,
    clinicTimeZone: dto.clinicTimeZone ?? null,
    workingWindowArtifact: dto.workingWindowArtifact === true,
    availabilityReason: resolveAvailabilityReason(dto),
  };
}

function resolveAvailabilityReason(dto: SlotItemDto): string | null
{
  switch (dto.blockReason?.trim()) {
    case 'device_downtime':
      return 'Blocked by device downtime';
    case 'specialist_downtime':
      return 'Blocked by specialist downtime';
    case 'device_inactive':
      return 'Blocked by inactive device';
    case 'specialist_inactive':
      return 'Blocked by inactive specialist';
    case 'specialist_procedure_unassigned':
      return 'Blocked by specialist procedure unassignment';
    case 'clinic_procedure_unassigned':
      return 'Blocked by clinic procedure change';
    case 'clinic_working_hours':
      return 'Blocked by clinic working hours';
    default:
      break;
  }

  switch (dto.blockSource?.trim()) {
    case 'downtime':
      return 'Blocked by downtime';
    case 'capacity_orchestration':
      return 'Blocked by capacity orchestration';
    case 'clinic_hours':
      return 'Blocked by clinic working hours';
    default:
      return null;
  }
}
